import { createLogic } from 'redux-logic'
import { map } from 'rxjs/operators'
import * as constants from '../constants'
import User from '@engine/user'

export const searchProjects = createLogic({
  type: constants.SEARCH_PROJECTS.ACTION,
  processOptions: {
    successType: constants.SEARCH_PROJECTS.FULFILLED,
    failType: constants.SEARCH_PROJECTS.REJECTED
  },
  process({ http, getState }) {
    const state = getState()
    const modifiedUserGuid = User.selectors.user.entityUserGuid(state)

    return http
      .post('/comps/projects/query', { ...state.comps.comps.pagination, userId: modifiedUserGuid })
      .pipe(map(http.getBody))
  }
})
